import React, { useState } from "react";
import Logo from "../../../images/as-logo.png";
import HeaderBackground from "../../../images/header-background.png";
import { Grid, makeStyles, Toolbar, Typography } from "@material-ui/core";
import { headerHeightMobile, headerHeight, headerHeightMobileXs } from "../../../constants";
import { navigate } from "@reach/router";
import { useCommonWidths } from "../../../hooks";
import { MyPageAppBarIconButton } from "../../common";
import { FormattedMessage } from "react-intl";

import MenuIcon from "@material-ui/icons/Menu";
import EmailIcon from "@material-ui/icons/Email";
import NotificationsIcon from "@material-ui/icons/Notifications";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { MyProfileMenuIcon } from "./MyProfileMenuIcon";
import { SideMenus, Menu } from "../sidemenus";
import { SsnImpersonaterTextField } from "./SsnImpersonaterTextField";

const useStyles = makeStyles((theme) => ({
	appBar: {
		backgroundImage: `url(${HeaderBackground})`,
		height: headerHeight,
		[theme.breakpoints.down("sm")]: {
			height: headerHeightMobile,
		},
		[theme.breakpoints.down("xs")]: {
			height: (isOnboardingHeader) => isOnboardingHeader
				? headerHeightMobileXs
				: headerHeightMobile
		},
		top: 0,
		position: "fixed",
		zIndex: 1300,
		width: "100%",
	},
	logo: {
		backgroundImage: "url(" + Logo + ")",
		backgroundRepeat: "no-repeat",
		backgroundSize: "300px",
		backgroundPosition: "center",
		height: 110,
		[theme.breakpoints.down("sm")]: {
			height: 110 - (headerHeight - headerHeightMobile),
		},
	},
	bottomBar: {
		height: 50,
		padding: 0,
	},
	notification: {
		color: "orange",
		position: "absolute",
		left: 0,
		top: 25,
		width: "auto",
		height: 30,
	},
	headerIcon: {
		width: "auto",
		height: 35,
	},
	hamburgerMenu: { marginLeft: 24 },
	appBarIconButtonsContainer: {
		flexWrap: "initial",
		height: "100%"
	}
}));

interface HeaderProps {
	authenticated?: boolean;
	userHasUnreadMessages?: boolean;
	userMatchesAdminPolicy?: boolean;
	isOnboardingHeader?: boolean;
}

export const Header = (props: HeaderProps) => {
	const { authenticated = false, userHasUnreadMessages, userMatchesAdminPolicy = false, isOnboardingHeader = false } = props;

	const classes = useStyles(isOnboardingHeader);
	const isMobile = useCommonWidths().isSmDown;

	const [openMenu, setOpenMenu] = useState(Menu.None);

	const toggleMenu = (toToggle: Menu): void => {
		if (!isMobile && toToggle === Menu.LeftMenu) return;
		if (toToggle === Menu.None) return;
		if (openMenu === toToggle) {
			setOpenMenu(Menu.None);
			return;
		}
		setOpenMenu(toToggle);
	};

	return (
		<div className={classes.appBar}>
			{authenticated && <SideMenus toggleMenu={toggleMenu} open={openMenu} />}
			<div className={classes.logo} />
			<Toolbar className={classes.bottomBar}>
				{authenticated && (
					<Grid container direction="row" justify="space-between" className={classes.appBarIconButtonsContainer} alignItems="center">
						<Grid item className={classes.hamburgerMenu}>
						{isMobile && (
								<MyPageAppBarIconButton
									label={
										<FormattedMessage
											id="minside.header.aria_label.main_menu"
											defaultMessage="Hovedmeny"
											description="Text for main menu aria label"
										/>
									}
									onClick={() => toggleMenu(Menu.LeftMenu)}
								>
									<MenuIcon />
								</MyPageAppBarIconButton>
						)}
						</Grid>
						{userMatchesAdminPolicy && !isMobile && (
							<Grid item>
								<SsnImpersonaterTextField />
							</Grid>
						)}
						<Grid item justify="flex-end" container direction="row">
						<MyPageAppBarIconButton
							label={
								<FormattedMessage
									id="minside.header.aria_label.messages"
									defaultMessage="Meldinger til innlogget bruker"
									description="Text for messages aria label"
								/>
							}
							onClick={() => navigate("/messages")}
						>
							<EmailIcon className={classes.headerIcon} />
							{userHasUnreadMessages && (
								<NotificationsIcon className={classes.notification} />
							)}
							{!isMobile && (
								<Typography variant="h6" style={{ marginLeft: 8 }}>
									<FormattedMessage
										id="minside.header.messages"
										defaultMessage="Meldinger"
										description="Text for messages button in header"
									/>
								</Typography>
							)}
						</MyPageAppBarIconButton>
						<MyPageAppBarIconButton
							label={
								<FormattedMessage
									id="minside.header.aria_label.faq_section"
									defaultMessage="FAQ seksjon"
									description="Text for faq aria label"
								/>
							}
							onClick={() => toggleMenu(Menu.FAQ)}
						>
							<HelpOutlineIcon className={classes.headerIcon} />
						</MyPageAppBarIconButton>
						<MyProfileMenuIcon onClick={() => toggleMenu(Menu.MyProfile)} />
						</Grid>
					</Grid>
				)}
			</Toolbar>
		</div>
	);
};
